import React from "react";
import { Link } from "gatsby"

import { Container, Row, Col } from "reusecore/Layout";
import Box from "reusecore/Box";
import Heading from "reusecore/Heading";
import Text from "reusecore/Text";
import BannerImage from "assets/images/header.png";
import particleTopLeft from "assets/images/particles/banner/particle-top-left.png";
import particleUnderLogo from "assets/images/particles/banner/particle-under-logo.png";
import prticleTopRight from "assets/images/particles/banner/prticle-top-right.png";
import particleBottomLeft from "assets/images/particles/banner/particle-bottom-left.png";
import particleBottomRight from "assets/images/particles/banner/particle-bottom-right.png";

import {FaGlasses} from 'react-icons/fa'

import BannerWrapper from "./banner.style";

const BannerTwo = ({h1, p1, span, cta, iconCta, image}) => {
  return (
    <BannerWrapper id="inicio">
      <img src={particleTopLeft} className="section__particle top-left" alt="cryptik particles"/>
      <img src={particleUnderLogo} className="section__particle two" alt="cryptik particles"/>
      <img src={prticleTopRight} className="section__particle top-right" alt="cryptik particles"/>
      <img src={particleBottomLeft} className="section__particle bottom-left" alt="cryptik particles"/>
      <img src={particleBottomRight} className="section__particle bottom-right" alt="cryptik particles"/>
      <Container>

        <Row>
     
          <Col className="lg-7 md-10 xs-12">
            <Box className="banner-content"> 
              <Heading>
                <h1>{h1}</h1>
                {p1}
              </Heading>
              <Text as="span" className="description">
               {span}
              </Text>
              <Box className="banner-btn">
                <Link to="#service" className="btn btn-fill">
                {iconCta}{cta}
                </Link> 
              </Box>
            </Box>
          </Col>
          <Col className="lg-5 md-2 xs-12">   <img src={image} /></Col>
        </Row>
      </Container>
    </BannerWrapper>
  );
};

export default BannerTwo;
